import styled from 'styled-components'
import { BREAKPOINTS } from '../../constants/breakpoints'

export const AnimalInsuranceTableContainer = styled.div`
  margin-bottom: 20px;
`

export const Title = styled.h1`
  margin-bottom: 20px;
  font-family: Ubuntu, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #0093b2;
`

export const TableContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  box-shadow: 0px 40px 40px 0px #0000001a;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`

export const Header = styled.th`
  padding: 8px;
  background-color: #0093b2;
  font-family: Ubuntu, sans-serif;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.05em;
  text-align: start;
  color: white;
  width: 100%;
`

export const IdHeader = styled(Header)`
  width: 48px;
`

export const ActionsHeader = styled(Header)`
  width: 90px;
`

export const Cell = styled.td`
  padding: 8px;
  font-family: Ubuntu, sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
  letter-spacing: 0.02em;
  max-width: 0;
  overflow: ${({ visible }: { visible: boolean }) =>
    visible ? 'visible' : 'hidden'};
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: start;
`

export const IdCell = styled(Cell)`
  padding: 8px;
  font-weight: 700;
  width: 48px;
  text-align: end;

  .alignIcon {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 8px;
    font-weight: 700;
    min-width: 48px;

    > span {
      height: 18px;
    }
  }

  .marginIcon {
    margin-right: 5px;
  }
`

export const ActionsCell = styled(Cell)`
  width: 70px;

  text-align: start;
  padding: 8px;
  font-weight: 700;
`

export const TableData = styled.tbody``

export const Row = styled.tr``

export const Actions = styled.div`
  display: flex;
  gap: 10px;
`

export const ButtonContainer = styled.span`
  display: flex;
  padding: 2px;
  justify-content: center;
  cursor: pointer;
`

export const DeleteButton = styled.img`
  cursor: pointer;
`

export const OpenCollapseButton = styled.img`
  cursor: pointer;
`

export const ExpandedRowInput = styled.div`
  padding: 10px 0px;
`

export const ExpandedRowDataLabel = styled.div`
  display: flex;
  font-family: Ubuntu, sans-serif;
  padding: 0px 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #6e6e6e;
`

export const ExpandedRowDataInput = styled.select`
  display: flex;
  border: 0px;
  background-color: transparent;
  width: 94%;
  border-bottom: 1px solid #6e6e6e;
  padding: 10px;
  color: #6e6e6e;
`

export const DateExpandedRowInput = styled.div`
  margin-top: -20px;
`

export const ExpandedRowDataInputText = styled.input`
  font-family: Ubuntu, sans-serif;
  border: 0px;
  background-color: transparent;
  width: 94%;
  border-bottom: 1px solid #6e6e6e;
  padding: 10px;
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #6e6e6e;
  max-width: 100%;
  overflow: hidden;
  &:focus {
    outline: none;
  }
`

export const ExpandedRowDataInputIcon = styled.img`
  padding-right: 10px;
`

export const ExpandedRowDataSecondaryLabel = styled.div`
  font-family: Ubuntu, sans-serif;
  font-size: 10px;
  font-weight: 300;
  line-height: 14px;
  letter-spacing: 0.02em;
  text-align: left;
  display: flex;
  align-items: end;
  margin-left: 5px;
  color: #6e6e6e;
`

export const ExpandedRowContainer = styled.tr``

export const ExpandedRow = styled.td`
  width: 100%;
`

export const ExpandedRowData = styled.div`
  font-family: Ubuntu, sans-serif;
  display: flex;
  flex-direction: column;
  width: 50%;
  margin: 0px auto;
`

export const TableActionsContainer = styled.tr``

export const ActionTab = styled.div`
  padding: 0 16px;

  @media ${BREAKPOINTS.md} {
    padding: 0 48px;
  }

  button {
    margin: 32px 0 0 auto;
  }
`

export const FormContainer = styled.div`
  padding: 0 16px;

  .message {
    padding: 0 16px;

    > div {
      margin: 0 !important;
    }
  }

  @media ${BREAKPOINTS.md} {
    padding: 0 32px;
  }

  > .row {
    width: 100%;
    margin: auto;

    @media ${BREAKPOINTS.md} {
      max-width: calc(100% - 32px);
      display: flex;
      gap: 32px;
    }

    > .col {
      width: 100%;

      @media ${BREAKPOINTS.md} {
        width: 50%;
      }

      > div,
      .DFdatePicker,
      .DFtextField,
      .DFnumberField {
        margin-top: 0;
      }

      .DFtextField label {
        text-align: left;
      }
    }
  }
`

export const TableActionsData = styled.td`
  width: 100%;
`

export const TableActions = styled.div`
  font-family: Ubuntu, sans-serif;
  display: flex;
  justify-content: flex-end;
  width: 60%;
  margin: 20px 20px 25px auto;
`

export const AddAnimalButtonContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  margin-left: auto;
  display: table;

  .button {
    gap: 8px;
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    &.disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
`

export const AddAnimalButtonText = styled.div`
  text-decoration: underline;
  font-family: Ubuntu, sans-serif;
  color: #6e6e6e;
  font-size: 12px;
  font-weight: 300;
  line-height: 15px;
  letter-spacing: 0.15em;
  text-align: left;
`

export const AddAnimalButtonIcon = styled.img``

export const AnimalRow = styled.tr``

export const InvalidRowIcon = styled.img`
  padding-right: 10px;
`
export const QuizContainer = styled.div`
  display: block;
  padding: 16px;
  border: 2px solid #f6f6f6;
  width: 100%;
  max-width: 1115px;
  margin: auto;

  .add-address {
    max-width: 600px;
    margin: auto;
    > div {
      padding-bottom: 0;
      padding-left: 0;
      margin-left: 0;
    }
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 32px;

  button {
    margin: 24px 0;
  }
`
